var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('img',{staticClass:"w-full",attrs:{"src":_vm.currentPreview,"alt":"current label"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }